'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

/**
 * Subscribed Counters Data Structure:
 *
 * @refCount Stands for the number of components interested in this counter. Similar to smart pointers.
 *   It makes sure that an entry is removed if it is no longer used (referenced).
 * @value The value of the counter.
 *
 * state.subscribedCounters = {
 *    [counterTypeId]: {      // E.g. The id for 'BusinessProcessAnsweredInteractions'
 *      [handlerId]: {        // E.g. The id for a specific BusinessProcess or agent
 *        refCount: 2,        // Number of components interested in this counter
 *        value: 'Sum of all dimensions',
 *        [dimensionId]: {    // E.g. The id for 'Telephony'
 *          refCount: 4,      // Number of components interested in this dimension
 *          value: 'Value per dimension' // Specific value for this dimension
 *        }
 *      }
 *    }
 *  }
 **/
const state = {
  AGENTS: [],
  BUSINESS_PROCESSES: [],
  agentsLastUpdate: null,
  lastKnownAgentStateChange: {
    online: '',
    ready: '',
    busy: '',
    break: '',
    backoffice: '',
    outgoing: ''
  },
  bpsLastUpdate: null,
  subscribedCounters: {}
};

export default {
  namespaced: true,

  /**
   * As a best practice: Actions call mutations which update our current state
   * Actions could execute sync or async operations.
   */
  actions,

  /**
   * Access to state values
   */
  getters,

  /**
   * Used to commit and track state changes
   * Mutations should always execute sync operations.
   */
  mutations,

  /**
   * Single source of truth
   */
  state
};
